module.exports = __webpack_public_path__ + "static/media/webdesign-services-img55.25f2e10c.jpg";